module.exports = __webpack_public_path__ + "img/ic_feedback.782cad94.png";